import { Cast } from '@mui/icons-material'
import VirtualExperienceUpsellingList from './VirtualExperiencesUpsellingList'
import VirtualExperienceUpsellingEdit from './VirtualExperiencesUpsellingEdit'
import VirtualExperienceUpsellingCreate from './VirtualExperienceUpsellingCreate'

const virtualUpsellingIndex = {
  icon: Cast,
  list: VirtualExperienceUpsellingList,
  edit: VirtualExperienceUpsellingEdit,
  create: VirtualExperienceUpsellingCreate,
}

export default virtualUpsellingIndex
